<div class="" *ngIf="getIdComponentByCode('ABOUT_US_PAGE_COMPONENT')">
  <app-html [componentId]="getIdComponentByCode('ABOUT_US_PAGE_COMPONENT')"></app-html>
</div>
